/** @jsxImportSource davaux/client */
import { reactive } from 'davaux'
import { createEffect, createSignal } from 'davaux/client'
import type { ButtonVariant } from './Button.js'
import { Button } from './Button.js'
import type { UiSize } from './types.js'

function ThemeToggle({
  variant = 'default',
  size = 'sm',
  lightLabel = '☀ Light',
  darkLabel = '☽ Dark',
}: {
  variant?: ButtonVariant
  size?: UiSize
  lightLabel?: string
  darkLabel?: string
}) {
  const initial =
    typeof document !== 'undefined'
      ? ((document.documentElement.getAttribute('data-dv-color-scheme') as 'dark' | 'light') ??
        'light')
      : 'light'

  const [theme, setTheme] = createSignal<'dark' | 'light'>(initial)

  createEffect(() => {
    if (typeof document === 'undefined') return
    document.documentElement.setAttribute('data-dv-color-scheme', theme())
    localStorage.setItem('dv-theme', theme())
  })

  return (
    <Button
      variant={variant}
      size={size}
      aria-label='Toggle color theme'
      onClick={() => setTheme(theme() === 'dark' ? 'light' : 'dark')}
    >
      <span class='dv-theme-toggle-light'>{lightLabel}</span>
      <span class='dv-theme-toggle-dark'>{darkLabel}</span>
    </Button>
  )
}

export default reactive(ThemeToggle)
